/**
 * Contact Selector — dropdown d'objet de demande + formulaires par objet.
 * Chaque panneau [data-contact-panel] porte un data-slug ; l'objet actif est reflété dans l'URL (?objet=slug).
 */

class ContactSelector extends HTMLElement {
  /** @type {HTMLSelectElement | null} */
  #select = null;
  /** @type {HTMLElement[]} */
  #panels = [];
  connectedCallback() {
    this.#select = this.querySelector('[data-contact-select]');
    this.#panels = [...this.querySelectorAll('[data-contact-panel]')];
    if (!this.#select) return;

    this.#select.addEventListener('change', () => this.#update(this.#select.value));

    const slug = new URLSearchParams(window.location.search).get('objet');
    if (slug && this.#panels.some((p) => p.dataset.slug === slug)) {
      this.#select.value = slug;
      // Le change bubblé synchronise aussi l'UI de <custom-select>
      this.#select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  #update(slug) {
    this.#panels.forEach((p) => p.classList.toggle('is-active', p.dataset.slug === slug));

    const url = new URL(window.location);
    if (slug) {
      url.searchParams.set('objet', slug);
    } else {
      url.searchParams.delete('objet');
    }
    window.history.replaceState({}, '', url);
  }
}

customElements.define('contact-selector', ContactSelector);
